const approvedAreasReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_APPROVED_AREAS':
      return [...action.payload];
    case 'ADD_APPROVED_AREA':
      return [...state, action.payload];
    case 'REMOVE_APPROVED_AREA':
      return state.filter(x => x.uid !== action.payload);
    case 'EDIT_APPROVED_AREA':
      return handleEdit(state, action.payload);
    default:
      return state;
  }
};

const handleEdit = (zones, zoneToEdit) => {
  const tmpState = zones.filter(zone => zone.uid !== zoneToEdit.uid);
  tmpState.push(zoneToEdit);

  return tmpState;
};

export default approvedAreasReducer;
